import React, { useState, useEffect, useContext } from "react";
import ReactStars from "react-rating-stars-component";
import SupplierContext from "context/SupplierContext";
import profile from "../../assets/images/profile.png";
import userlogo from "../../assets/images/user-icon.png";
import "./Comments1.scss";
import { connection } from "utils/apiConnection.ts";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import AuthenticationContext from "../../Authentication/AuthenticationContext.ts";

import { RiDeleteBin5Fill } from "react-icons/ri";
const Comments = ({
  commentUpdater,
  setCommentUpdater,
  selectedBasket,
  isProduct = false
}) => {
  const [comments, setComments] = useState([]);
  const { isLogged, userInfo } = useContext(AuthenticationContext);

  // console.log("userInfo", userInfo);
  useEffect(() => {
    let fd = {};
    if (isProduct) {
      fd.product_id = product.info.avb_product_for_order__id;
    } else {
      fd.rto_basket_id =
        // fd.basket_id =
        selectedBasket.basket_supplier &&
        selectedBasket.basket_supplier.ready_to_order_basket__id;
    }

    connection("api/get_comments", fd).then(data => {
      // product_id: product.info.avb_product_for_order__id,
   
      setComments(data.data);
    });
  }, [commentUpdater, selectedBasket]);
  const { product, setProduct } = useContext(SupplierContext);

  const deleteComment = index => {
    Swal.fire({
      title: "آیا از حذف دیدگاه اطمینان دارید؟",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "حذف",
      cancelButtonText: "انصراف"
    }).then(result => {
      if (result.isConfirmed) {
        let cond = "";
        if (isProduct) {
          cond = `apfo_id,${product.info.avb_product_for_order__id}@@supplier_id,${product.info.supplier_id}@@`;
        } else {
          cond = `rto_basket_id,${selectedBasket.basket_supplier.ready_to_order_basket__id}@@supplier_id,${selectedBasket.basket_supplier.supplier_id}@@`;
        }
        connection("api/Update_Comments", {
          conditions: `id/=/${comments[index].id}`,
          keyvalues: `${cond}upuid,${userInfo.id}@@uptm,${Date.now()
            .toString()
            .slice(0, -3)}@@status,-1`
        }).then(data => {
          if (data.status == 1) {
            Swal.fire("دیدگاه با موفقیت حذف شد.");
            // navigate("/", { replace: true });
            setCommentUpdater(prev => {
              return !prev;
            });
          } else {
            Swal.fire("مشکلی در حذف دیدگاه پیش آمده است.");
          }
        });
      }
    });
  };
  return (
    <div className="comments">
      <div>
        {comments &&
          comments.reverse().map((value, index) => {
            return (
              <div className="card-com col-12 col-md-10 col-xxl-8" key={index}>
                {isProduct
                  ? isLogged &&
                    userInfo.supplier_list.includes(
                      product.info.supplier_id.toString()
                    ) && (
                      <div className="text-end">
                        <button
                          class="btn btn-danger"
                          onClick={() => {
                            deleteComment(index);
                          }}
                        >
                          <RiDeleteBin5Fill />
                        </button>
                      </div>
                    )
                  : isLogged &&
                    selectedBasket.length > 0 &&
                    userInfo.supplier_list.includes(
                      selectedBasket.basket_supplier.supplier_id.toString()
                    ) && (
                      <div className="text-end">
                        <button
                          class="btn btn-danger"
                          onClick={() => {
                            deleteComment(index);
                          }}
                        >
                          <RiDeleteBin5Fill />
                        </button>
                      </div>
                    )}

                <div className="rate">
                  <ReactStars
                    count={5}
                    size={24}
                    isHalf={true}
                    edit={false}
                    dir={"ltr"}
                    value={value.apfo_rate}
                    emptyIcon={<i className="far fa-star"></i>}
                    halfIcon={<i className="fa fa-star-half-alt"></i>}
                    fullIcon={<i className="fa fa-star"></i>}
                    activeColor="white"
                  />
                  <div className="valueRate">{value.apfo_rate}/5</div>
                </div>
                <div className="description">
                  <div className="info col-12 col-md-2">
                    <div className="pic">
                      {value.user_info.path ? (
                        <img
                          src={` http://sabadi.tatdemo.ir/${value.user_info.path}`}
                          style={{ width: "50px", height: "50px" }}
                        />
                      ) : (
                        <img
                          src={userlogo}
                          style={{ width: "50px", height: "50px" }}
                        />
                      )}
                    </div>
                    <div className="name">
                      {value.user_info.fullname != ""
                        ? value.user_info.fullname
                        : "کاربر سبدی"}
                    </div>
                  </div>
                  <div className="text col-12 col-md-9">
                    {value.comment_txt}
                  </div>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default Comments;
